import React, {useEffect} from 'react';
// import styled from 'styled-components';

import AnalyticsService from '../../services/AnalyticsService';

import Meta from '../layout/Meta';
import Layout from '../layout/Layout';
import Header from '../layout/Header';
import Section from '../layout/Section';
import Padding from '../layout/Padding';
import Typo from '../../common/components/Typo';



const Servizi = ({layout}) => {
  useEffect(() => {
    AnalyticsService.init();  
  }, []);

  return (
    <Layout layout={layout}>
      <Meta
        title={"Servizi"}
        description={"Servizi di Autofficina a Mantova"}
      />
      <Header 
        uppertext={"Servizi"}
        text={"Autofficina ACS"}
        lowertext={"di Meneghel Mirko e Juri SAS"}
        page="servizi"
        alt="Emotional image"
      />
      
      <Section 
        variant="white" 
        imageDx={"/web/sections/servizi-riparazioni.jpg"}
      >
        <Padding top right bottom left>
          <Typo type="h2" align="center">Riparazioni meccaniche</Typo>
          <Typo type="p">
            <ul>
              <li>Interventi su auto e furgoni di tutte le marche</li>
              <li>Servizio di ritiro vettura marciante direttamente a casa del cliente</li>
              <li>Utilizzo esclusivo di ricambi di alta qualità</li>
              <li>Controlli accurati su tutte le vetture per garantire sicurezza e prestazioni ottimali</li>
            </ul>
          </Typo>          
        </Padding>
      </Section>
      
      <Section 
        variant="lightblue" 
        imageSx={"/web/sections/servizi-tagliandi.jpg"}
      >
        <Padding top right bottom left>
          <Typo type="h2" align="center">Tagliandi e manutenzione</Typo>
          <Typo type="p">
            <ul>
              <li>Tagliandi completi per qualsiasi veicolo, inclusi quelli ancora coperti da garanzia ufficiale della casa madre</li>
              <li>Servizio disponibile anche per vetture ibride</li>
              <li>Verifica e sostituzione di liquidi e filtri, controllo generale del veicolo</li>
            </ul>
          </Typo>          
        </Padding>
      </Section>
      
      <Section 
        variant="white" 
        imageDx={"/web/sections/servizi-installazioni.jpg"}
      >
        <Padding top right bottom left>
          <Typo type="h2" align="center">Installazione e montaggi</Typo>
          <Typo type="p">
            <ul>
              <li>Montaggio ganci traino di alta qualità con autorizzazione e firma depositata presso M.C.T.C.</li>
              <li>Preparazione veicoli per revisione</li>
            </ul>
          </Typo>          
        </Padding>
      </Section>
      
      <Section 
        variant="lightblue" 
        imageSx={"/web/sections/servizi-elettrauto.jpg"}
      >
        <Padding top right bottom left>
          <Typo type="h2" align="center">Servizi di elettrauto</Typo>
          <Typo type="p">
            <ul>
              <li>Ricarica climatizzatori per vetture di vecchia e nuova generazione</li>
              <li>Installazione e sostituzione autoradio e impianti audio</li>
              <li>Riparazione e manutenzione di impianti elettrici</li>
            </ul>
          </Typo>          
        </Padding>
      </Section>
      
      <Section 
        variant="white" 
        imageDx={"/web/sections/servizi-gommista.jpg"}
      >
        <Padding top right bottom left>
          <Typo type="h2" align="center">Gommista</Typo>
          <Typo type="p">
            <ul>
              <li>Riparazione e sostituzione pneumatici di varie marche</li>
              <li>Servizi di equilibratura, assetto e regolazione</li>
              <li>Firma depositata per interventi certificati</li>
            </ul>
          </Typo>          
        </Padding>
      </Section>
    </Layout>
  )
}

export default Servizi
